import TakMatlab from "components/takMatlab/TakMatlab";

const MatlabPage = () => {
  return (
    <>
      <TakMatlab />
    </>
  );
};

export default MatlabPage;
